import { CommonModule } from '@angular/common';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { GTAG_TOKEN } from './gtag-token';
import { GtagService } from './gtag.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: GTAG_TOKEN,
      useFactory: () => window.gtag ?? (() => {}),
    },
    GtagService,
    provideAppInitializer(() => {
      const initializerFn = initializePageTracking(inject(Router), inject(GtagService));
      return initializerFn();
    }),
  ],
})
export class AnalyticsModule {}

function initializePageTracking(router: Router, gtagService: GtagService): () => void {
  return () => {
    router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        gtagService.trackPageView(event.urlAfterRedirects);
      });
  };
}
